import { jsxs as B, jsx as o } from "react/jsx-runtime";
import r from "react";
import { Button as D } from "../Button/Button.js";
import { I as F } from "../../Icons-NE1cibCU.js";
import { clsx as L } from "../../utils/clsx.js";
import { useDynamicRef as i } from "../../utils/hooks.js";
import '../../assets/RichInput.css';const T = "_root_16on4_1", j = "_renderer_16on4_1", z = "_small_16on4_8", E = "_large_16on4_13", H = "_clear_16on4_95", t = {
  root: T,
  renderer: j,
  small: z,
  large: E,
  clear: H
}, O = r.forwardRef(function(f, m) {
  const {
    size: d = "normal",
    value: c,
    onChange: p,
    onFocus: _,
    onBlur: h,
    onSelect: g,
    onKeyDown: C,
    className: R,
    rendered: S,
    placeholder: x,
    autoFocus: k,
    withClearButton: I = !1
  } = f, s = r.useRef(null), n = r.useRef(null), a = i(p), u = i(g), N = r.useCallback((e) => {
    a.current(e.target.value);
  }, []), b = r.useCallback(() => {
    var e;
    a.current(""), (e = s.current) == null || e.focus();
  }, []), v = r.useCallback((e) => {
    if (!u.current || !(e.target instanceof HTMLInputElement))
      return;
    const l = e.target;
    u.current(l.selectionStart, l.selectionEnd, l.selectionDirection);
  }, []), w = r.useCallback((e) => {
    n.current && (n.current.scrollTop = e.target.scrollTop, n.current.scrollLeft = e.target.scrollLeft);
  }, []), y = L(t.root, R, t[d]);
  return /* @__PURE__ */ B("div", { ref: m, className: y, children: [
    /* @__PURE__ */ o(
      "input",
      {
        ref: s,
        autoFocus: k,
        type: "text",
        value: c,
        onChange: N,
        placeholder: x,
        onBlur: h,
        onFocus: _,
        onScroll: w,
        onSelect: v,
        onKeyDown: C
      }
    ),
    /* @__PURE__ */ o("div", { ref: n, className: t.renderer, children: S }),
    I && c && /* @__PURE__ */ o("div", { className: t.clear, children: /* @__PURE__ */ o(D, { size: "small", icon: F.exit, onClick: b }) })
  ] });
});
export {
  O as RichInput
};
